import { Flex, Text, Box } from "@chakra-ui/react";
import { Modal } from "antd";
import FooterModal from "components/Button/FooterModal";
import { OperacaoEnum } from "core/resources/enums/conta";
import { useContaStore } from "features/conta/store";
import { ContaFiltroType } from "features/conta/typings";
import { useEffect, useRef, useMemo } from "react";
import useContaRecorrenteLancamentos from "core/features/conta-recorrente/hooks/useContaRecorrenteLancamentos";
import useContaRecorrenteLancamentosTableColumns from "./hooks/useContaRecorrenteLancamentosTableColumns";
import { ContaRecorrenteLancamentoItemResponse } from "features/conta-recorrente/typings";
import InfiniteScroll from "react-infinite-scroll-component";
import InfiniteScrollLoader from "components/InfiniteScrollLoader";
import NewTable from "components/NewTable";
import HeaderTable from "components/Page/HeaderTable";

interface ModalContasLancadasProps {
  id: string;
  isOpen: boolean;
  onClose?: () => any;
  operacao: OperacaoEnum;
}

export default function ModalContasLancadas({
  id,
  isOpen,
  onClose,
  operacao,
}: ModalContasLancadasProps) {
  const { update, filters, reset } = useContaStore();
  const initialFiltersRef = useRef(filters);

  useEffect(() => {
    let next: Partial<ContaFiltroType> = {};

    next = {
      operacao,
      dataInicio: null,
      dataFim: null,
      contasRecorrentesIds: [id],
      orderDirection: "DESC",
    };

    reset(next);

    const _initialFilters = initialFiltersRef.current;
    return () => {
      reset(_initialFilters);
    };
  }, [id, operacao, reset]);

  const {
    isLoading: isLoadingContas,
    isFetchingNextPage,
    hasNextPage,
    fetchNextPage,
    data,
  } = useContaRecorrenteLancamentos(id, filters);

  const columns = useContaRecorrenteLancamentosTableColumns(filters.operacao);

  const items = useMemo(() => {
    return (
      data?.pages.reduce(
        (agg: ContaRecorrenteLancamentoItemResponse[], page) =>
          agg.concat(page.items ?? []),
        []
      ) ?? []
    );
  }, [data]);

  return (
    <>
      <Modal
        centered
        visible={isOpen}
        footer={
          <FooterModal
            showRegisterAnother={false}
            hidePrimaryButton
            buttonCancelarText="Fechar"
            onClose={onClose}
          />
        }
        width="1500px"
        onCancel={onClose}
      >
        <Flex flexDir="column">
          <Text as="h3" fontSize={20} fontWeight="500" mb="24px" mt={-2}>
            Contas lançadas
          </Text>

          <Box
            id="lista-lancamentos-conta-corrente"
            className="custom-scroll-bar"
            maxH="45vh"
            overflowY="auto"
          >
            <InfiniteScroll
              scrollableTarget="lista-lancamentos-conta-corrente"
              dataLength={items.length}
              next={() => {
                fetchNextPage();
              }}
              scrollThreshold={0.1}
              hasMore={!!hasNextPage}
              loader={isFetchingNextPage ? <InfiniteScrollLoader /> : null}
            >
              <NewTable
                loading={isLoadingContas}
                dataSource={items ?? []}
                columns={columns}
                title={() => (
                  <HeaderTable
                    value={filters?.search || ""}
                    onSearch={(q?: string) => update("search", q)}
                  />
                )}
              />
            </InfiniteScroll>
          </Box>
        </Flex>
      </Modal>
    </>
  );
}
